function getToken() {
  if ((isLocallyServed() || isDevServed()) && process.env.NODE_ENV === 'development') {
    return '4cbe51cf-a294-35a8-b3ae-d3cc89abf29c';
  } else {
    return 'fcbe54cf-a294-45a8-b3ae-d3cc89abf29c';
  }
}

function isLocallyServed() {
  return (
    window.location.hostname.includes('localhost') || window.location.hostname.includes('ngrok')
  );
}

function isDevServed() {
  return window.location.hostname.includes('devreports');
}

function isAcceptanceServed() {
  return window.location.hostname.includes('acceptancereports');
}

const AppHelper = {
  isLocallyServed,
  isDevServed,
  isAcceptanceServed,
  getToken
};

export default AppHelper;
